import { SignedIn, SignedOut, useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import QalicoLogoWhite from '@/assets/qalico-logo-white.svg?react';
import SignInPage from '@/pages/Authentication/SignIn';
import { useWorkspacesService } from '@/services/workspaces';
import {
  getLastVisitedWorkspaceUname,
  getRestoredAppPath,
} from '@/utils/lastWorkspaceSession';

function WorkspaceSetupContent() {
  const { isLoaded } = useUser();
  const { workspaces, error } = useWorkspacesService();
  const navigate = useNavigate();

  useEffect(() => {
    if (!workspaces || workspaces.length === 0) return;

    const workspaceUname =
      getLastVisitedWorkspaceUname(workspaces) ?? workspaces[0].uname;

    const restored = getRestoredAppPath(workspaces);
    if (restored) {
      navigate(restored, { replace: true });
    } else {
      navigate(`/workspace/${workspaceUname}`, { replace: true });
    }
  }, [workspaces, navigate]);

  if (!isLoaded) {
    return null;
  }

  if (error) {
    return (
      <div className="h-screen w-screen bg-[#130e30] flex flex-col items-center justify-center">
        <div className="absolute top-8 left-10">
          <QalicoLogoWhite className="h-[51px] w-auto" />
        </div>
        <div className="flex flex-col items-center gap-4 max-w-md text-center">
          <h2 className="text-2xl font-semibold text-red-400">
            Error loading workspace
          </h2>
          <p className="text-white/60">
            There was an error setting up your workspace. Please try refreshing
            the page.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen w-screen bg-[#130e30] flex flex-col items-center justify-center">
      <div className="absolute top-8 left-10">
        <QalicoLogoWhite className="h-[51px] w-auto" />
      </div>
      <div className="size-8 rounded-full border-2 border-white border-t-transparent animate-spin" />
    </div>
  );
}

export function WorkspaceSetupPage() {
  return (
    <>
      <SignedIn>
        <WorkspaceSetupContent />
      </SignedIn>
      <SignedOut>
        <SignInPage />
      </SignedOut>
    </>
  );
}
